var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 100,
    viewBox: "0 0 113 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.002 50C102.002 77.4723 79.4002 99.7493 51.5114 99.7493C23.6227 99.7493 1.02069 77.4723 1.02069 50C1.02069 22.5277 23.6227 0.250671 51.5114 0.250671C79.4002 0.250671 102.002 22.5277 102.002 50Z",
    fill: "#E0F1FE",
    stroke: "#C4E3FE",
    strokeWidth: 0.501343
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.444,
    y: 46.8288,
    width: 13.6377,
    height: 0.891906,
    rx: 0.445953,
    fill: "#005DAA",
    stroke: "#005DAA",
    strokeWidth: 0.501343
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.02069,
    y: 58.3522,
    width: 13.6377,
    height: 0.891906,
    rx: 0.445953,
    fill: "#005DAA",
    stroke: "#005DAA",
    strokeWidth: 0.501343
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105.411,
    y: 46.8288,
    width: 6.5682,
    height: 0.891906,
    rx: 0.445953,
    fill: "#005DAA",
    stroke: "#005DAA",
    strokeWidth: 0.501343
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9792,
    y: 51.9421,
    width: 6.5682,
    height: 0.891906,
    rx: 0.445953,
    fill: "#005DAA",
    stroke: "#005DAA",
    strokeWidth: 0.501343
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.55536,
    y: 63.4655,
    width: 6.5682,
    height: 0.891906,
    rx: 0.445953,
    fill: "#005DAA",
    stroke: "#005DAA",
    strokeWidth: 0.501343
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3023 67.9943H33.2363C32.5218 67.9943 31.8615 67.613 31.5043 66.9943C31.147 66.3755 31.147 65.6131 31.5043 64.9943L50.0363 32.9943C50.3938 32.3765 51.0535 31.9961 51.7673 31.9961C52.4811 31.9961 53.1407 32.3765 53.4983 32.9943L72.0303 64.9943C72.3874 65.6128 72.3876 66.3747 72.0308 66.9934C71.674 67.6121 71.0144 67.9935 70.3003 67.9943H70.3023ZM51.7703 37.9943L36.7083 63.9943H66.8363L51.7703 37.9943ZM53.7603 55.9963H49.7603V45.9943H53.7603V55.9963Z",
    fill: "#003C77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7703 57.9983H53.7703V61.9983H49.7703V57.9983Z",
    fill: "#003C77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.fc6f1e395d74d5a94bc0dac8b6693c90.svg";
export { ForwardRef as ReactComponent };